import Navbar from '@/components/feature/Navbar';
import Footer from '@/components/feature/Footer';
import ScrollToTop from '@/components/base/ScrollToTop';
import HeroSection, { PopularSection, LatestSection, CategoryTagsSection, StatsSection, FAQSection } from './components/Sections';

export default function Home() {
  return (
    <>
      <Navbar />
      <main>
        <HeroSection />
        <PopularSection />
        <StatsSection />
        <LatestSection />
        <CategoryTagsSection />
        <FAQSection />
      </main>
      <Footer />
      <ScrollToTop />

      <script
        type="application/ld+json"
        dangerouslySetInnerHTML={{
          __html: JSON.stringify({
            '@context': 'https://schema.org',
            '@type': 'WebPage',
            name: '43423漫画网 - 下拉式漫画免费看',
            description: '43423漫画网提供下拉式漫画免费阅读，支持漫画下拉式上下滑动浏览，下拉式漫画大全，好看的漫画下拉式在线看。',
            url: 'https://43423mh.com/',
            isPartOf: {
              '@type': 'WebSite',
              name: '43423漫画网',
              url: 'https://43423mh.com/',
            },
            breadcrumb: {
              '@type': 'BreadcrumbList',
              itemListElement: [
                {
                  '@type': 'ListItem',
                  position: 1,
                  name: '首页',
                  item: 'https://43423mh.com/',
                },
              ],
            },
          }),
        }}
      />
      <script
        type="application/ld+json"
        dangerouslySetInnerHTML={{
          __html: JSON.stringify({
            '@context': 'https://schema.org',
            '@type': 'FAQPage',
            mainEntity: [
              {
                '@type': 'Question',
                name: '什么是下拉式漫画？',
                acceptedAnswer: {
                  '@type': 'Answer',
                  text: '下拉式漫画是一种新型的漫画阅读方式，区别于传统的左右翻页模式，下拉式漫画采用上下滑动浏览的方式，读者只需要用手指或鼠标向下滑动，就可以连续不断地阅读漫画内容，阅读体验更加流畅自然。',
                },
              },
              {
                '@type': 'Question',
                name: '43423漫画网的漫画都是免费的吗？',
                acceptedAnswer: {
                  '@type': 'Answer',
                  text: '是的，43423漫画网上的所有漫画资源均为免费提供。我们致力于为广大漫画爱好者打造一个优质的免费下拉式漫画阅读平台。',
                },
              },
              {
                '@type': 'Question',
                name: '支持哪些类型的漫画？',
                acceptedAnswer: {
                  '@type': 'Answer',
                  text: '43423漫画网提供丰富的漫画类型，包括韩漫下拉式、日漫下拉式、恋爱、热血、奇幻、搞笑、悬疑、校园、都市等多种分类。',
                },
              },
              {
                '@type': 'Question',
                name: '如何快速找到想看的漫画？',
                acceptedAnswer: {
                  '@type': 'Answer',
                  text: '你可以通过首页的分类导航快速找到感兴趣的类型，也可以使用搜索功能输入漫画名称查找。我们还会定期更新热门推荐和最新更新列表。',
                },
              },
            ],
          }),
        }}
      />
    </>
  );
}